import { EExchangeBoardType } from "../types/exchangeBoard.type";
import { ExchangeBoardProperties } from "../types/exchangeBoard.type";
import { normalizePhoneNumber } from "./phone";
import { formatDate } from "./format";

export const renderExchangeBoardType = (type: EExchangeBoardType) => {
	switch (type) {
		case EExchangeBoardType.WTB:
			return "WTB";

		case EExchangeBoardType.WTR:
			return "WTR";

		case EExchangeBoardType.FOR_RENT:
			return "For Rent";

		case EExchangeBoardType.FOR_SALE:
			return "For Sale";
	}
};

export const doWhatsAppExchangeBoard = (exchangeBoard: ExchangeBoardProperties, areaName?: string) => {
	if (!exchangeBoard || !exchangeBoard.picProfile?.firstPhoneNumber) return;

	let phone = normalizePhoneNumber(exchangeBoard.picProfile.firstPhoneNumber);
	if (!phone) return;


	const titleText = exchangeBoard.titlePlainText || exchangeBoard.title;
	const location = areaName || exchangeBoard.city || "Not specified";

	let message = `Hi ${exchangeBoard.picUser?.nickName}, saya tertarik dengan Request Board Anda berikut:

${titleText}

- Tipe: ${renderExchangeBoardType(exchangeBoard.type)}
- Lokasi: ${location}
- Tipe Properti: ${exchangeBoard.listingPropertyType?.name || "Not specified"}
- Tanggal Posting: ${formatDate(exchangeBoard.createdAt)}

Mohon informasinya lebih lanjut, terima kasih.`;

	let sendURL = `https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(
		message
	)}&type=phone_number&app_absent=0`;

	return Object.assign(document.createElement("a"), { target: "_blank", href: sendURL }).click();
};

export const getExchangeBoardStatusColor = (isExpired: boolean): string => {
	return isExpired ? "#ff4d4f" : "#52c41a";
};

export const getExchangeBoardStatusText = (isExpired: boolean): string => {
	return isExpired ? "EXPIRED" : "ACTIVE";
};

export const isExchangeBoardExpiringSoon = (expiredAt: Date): boolean => {
	if (!expiredAt) return false;
	
	const now = new Date();
	const expiry = new Date(expiredAt);
	const daysDiff = Math.ceil((expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
	
	return daysDiff <= 7 && daysDiff > 0;
};
